<template>
  <el-dialog
    :title="$t('text.Observations')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="400px"
  >
    <template>
      <el-table :data="observations" border :max-height="500" size="small">
        <el-table-column prop="ObservationName" :label="$t('text.name')">
        </el-table-column>
        <el-table-column prop="ObservationCount" :label="$t('text.count')">
        </el-table-column>
      </el-table>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  props: {
    observations: {
      type: Array,
      require: true
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>
